import Link from '@/components/Common/Link'

const Button = ({ data }) =>
  data.url ? (
    <Link
      href={data.url}
      className="bg-brand-green-dark hover:scale-98 cursor-pointer rounded-full px-5 py-2 text-center text-white transition-colors hover:bg-[#288A3F]"
    >
      {data.title}
    </Link>
  ) : (
    <div className="bg-brand-green-dark hover:scale-98 cursor-pointer rounded-full px-5 py-2 text-center text-white transition-colors hover:bg-[#288A3F]">
      {data.title}
    </div>
  )

export default Button
